<div class="content-wrapper" *blockUI="'section-block'">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>

    <div class="content-body" *ngIf="isUpdate">

        <div class="card col-12">
            <div class="card-body">
                <div class="d-flex justify-content-between align-items-center mb-1">
                    <div class="col-8">
                        <h6 class="card-title mb-0">Talep Adı: <strong>{{requestTask.title}}</strong></h6>
                        <h6 class="card-subtitle text-muted mt-1">Talep No: {{requestTask.no}}</h6>
                        <h6 class="card-subtitle text-muted mt-1">Başlangıç Tarihi: {{requestTask.startDate |
                            date:'dd/MM/yyyy'}} </h6>
                    </div>

                    <div [ngClass]="getStatusClass(requestTask.status)">
                        {{ getStatusText(requestTask.status) }}
                    </div>
                </div>
                <p class="ml-1 mb-2 mt-2"><strong>Açıklama:</strong> {{requestTask.description}}</p>
                <div class="row col-12 table-responsive">
                    <div class="col-6">
                        <h6>Firma bilgileri</h6>
                        <hr>
                        <p>{{requestTask.companyName}}</p>
                        <p>{{requestTask.companyPersonName}} {{requestTask.companyPersonLastName}}</p>
                        <p>{{requestTask.companyPersonMail}}</p>
                        <p>{{requestTask.companyPersonPhoneNumber}}</p>
                    </div>
                    <div class="col-6">
                        <h6>Sorumlu bilgileri</h6>
                        <hr>
                        <p>{{requestTask.personName}} {{requestTask.lastName}}</p>
                        <p>{{requestTask.personMail}}</p>
                        <p>{{requestTask.personPhoneNumber}}</p>
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-end mb-1">
                <button type="button" class="btn btn-icon btn-flat-success" rippleEffect (click)="updateChange()">
                    <span [data-feather]="'edit'"></span></button>
            </div>
        </div>

        <ul ngbNav #nav="ngbNav" class="nav-tabs">
            <li ngbNavItem>
                <a ngbNavLink>İşlemler</a>
                <ng-template ngbNavContent>
                    <div class="card">
                        <div class="card-body table-responsive">
                            <h4>İşlemler</h4>
                            <!-- ngx-datatable-row-details -->
                            <ngx-datatable #tableRowDetails class="bootstrap core-bootstrap"
                                [columnMode]="ColumnMode.force" [headerHeight]="40" [footerHeight]="50" [rowHeight]="58"
                                [limit]="10" [rows]="transactionManagement" [scrollbarH]="true">
                                <!-- Row Detail Template -->
                                <ngx-datatable-row-detail [rowHeight]="rowHeight" [width]="550">
                                    <ng-template let-row="row" let-expanded="expanded"
                                        ngx-datatable-row-detail-template>
                                        <div class="ml-15 pl-1 pt-15">
                                            <table class="table table-responsive" *blockUI="'section-block'">
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Ürün Adı</th>
                                                        <th>Adet</th>
                                                        <th>Fiyat</th>
                                                        <th>İndirim.O</th>
                                                        <th>Vergi</th>
                                                        <th>Toplam</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let item of products; let i = index">
                                                        <td>{{i + 1}}</td>
                                                        <td>{{item.name | slice:0:20}} {{ item.name.length > 24 ? '...'
                                                            : '' }}</td>
                                                        <td>{{item.productCount}}</td>
                                                        <td>{{item.productPrice}}</td>
                                                        <td>{{item.discountRate}}</td>
                                                        <td>{{item.taxRate}}</td>
                                                        <td>
                                                            {{ calculateTotal(item.productCount, item.productPrice,
                                                            item.discountRate, item.taxRate) | number:'1.2-2' }}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </ng-template>
                                </ngx-datatable-row-detail>
                                <ngx-datatable-column [width]="250" [resizeable]="false" [sortable]="false"
                                    [draggable]="false" [canAutoResize]="false">
                                    <ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
                                        <a href="javascript:void(0)" [class.datatable-icon-right]="!expanded"
                                            [class.datatable-icon-down]="expanded" title="Expand/Collapse Row"
                                            (click)="rowDetailsToggleExpand(row)">
                                        </a>
                                    </ng-template>
                                </ngx-datatable-column>

                                <ngx-datatable-column name="No" prop="no" [width]="250"></ngx-datatable-column>
                                <ngx-datatable-column name="Ürün Sayısı" prop="productCount"
                                    [width]="50"></ngx-datatable-column>
                                <ngx-datatable-column name="Tür" prop="kindName" [width]="120"></ngx-datatable-column>
                                <ngx-datatable-column name="Bitiş Tarihi">
                                    <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                        {{row.validityDate | date:'dd.MM.yyyy'}}
                                    </ng-template>
                                </ngx-datatable-column>

                            </ngx-datatable>
                            <!-- ngx-datatable-row-details -->
                            <!-- 
                            <table class="table" *ngIf="transactionManagement.length > 0">
                                <thead>
                                    <tr>
                                        <th>Sipariş No</th>
                                        <th>Ürün Sayısı</th>
                                        <th>Tür</th>
                                        <th>Bitiş Tarihi</th>
                                        <th>Detaylar</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of transactionManagement; let i = index">
                                        <td><span>{{item.no}}</span></td>
                                        <td>{{ item.productCount }}</td>
                                        <td>{{item.kindName}}</td>
                                        <td>{{item.validityDate | date:'dd/MM/yyyy'}}</td>
                                        <td>
                                            <button (click)="toggleExpand(i)">Detaylar</button>
                                        </td>
                                    </tr>

                                    <tr *ngIf="expandedIndex === i">
                                        <td colspan="5">
                                            <div class="expanded-content">
                                                Burada genişleyen satırda göstermek istediğiniz içeriği koyabilirsiniz 
                                                <p>Bu siparişle ilgili daha fazla detay burada görünecek.</p>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table> -->
                        </div>
                    </div>
                </ng-template>
            </li>
            <li ngbNavItem>
                <a ngbNavLink>Aksiyonlar</a>
                <ng-template ngbNavContent>
                    <div class="card table-responsive">

                        <div class="card-body">
                            <button type="button" class="btn btn-success btn-sm d-flex align-items-center mb-1"
                                (click)="createActions(null)">
                                Aksiyon Ekle
                            </button>
                            <h4>Aksiyonlar</h4>
                            <table class="table" *ngIf="actions.length > 0">
                                <thead>
                                    <tr>
                                        <th>No</th>
                                        <th>Başlık</th>
                                        <th>Durum</th>
                                        <th>Tarihi</th>
                                        <th>#</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item2 of actions">
                                        <td><span>{{item2.no}}</span></td>
                                        <td>{{ item2.title }}</td>
                                        <td>
                                            <div [ngClass]="getStatusClassTransaction(item2.status)">
                                                {{ getStatusTextTransaction(item2.status) }}
                                            </div>
                                        </td>
                                        <td>{{item2.startActionDate | date:'dd/MM/yyyy'}} - {{item2.finishActionDate
                                            |date:'dd/MM/yyyy'}}</td>
                                        <td>
                                            <a (click)="createActions(item2.id)">
                                                <i data-feather="edit" class="text-success cursor-pointer"></i>
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </ng-template>
            </li>

            <li ngbNavItem>
                <a ngbNavLink>Dosyalar</a>
                <ng-template ngbNavContent>
                    <div class="card">
                        <div class="row">
                            <div class="form-group col-md-5 ml-1 mt-1">
                                <input type="file" accept=".doc, .docx, .pdf, .xls, .xlsx, .ppt, .pptx, .txt"
                                    class="custom-file-input" id="customFile" (change)="onFileSelected($event)" />
                                <label class="custom-file-label" for="customFile">{{ fileName }}</label>
                            </div>
                            <div class="col-md-2 col-12 mt-1">
                                <button type="button" class="btn btn-success btn-sm d-flex align-items-center mb-1"
                                    [disabled]="selectedFiles.length < 1" (click)="createFile()">
                                    Dosya Ekle
                                </button>
                            </div>
                        </div>
                        <div class="card-body table-responsive">

                            <ngx-datatable [rows]="files" [rowHeight]="50" class="bootstrap core-bootstrap"
                                style="cursor: pointer;" [messages]="{ 
                                emptyMessage: 'Veri Yok',
                                totalMessage: 'Toplam', 
                                selectedMessage: 'Seçili'
                              }" [limit]="5" [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50"
                                [scrollbarH]="true">

                                <ngx-datatable-column name="Dosya Adı" prop="fileName"
                                    [width]="200"></ngx-datatable-column>
                                <ngx-datatable-column name="Dosya Türü" [width]="200">
                                    <ng-template let-row="row" ngx-datatable-cell-template>
                                        {{ getFileExtension(row.fileName) }}
                                    </ng-template>
                                </ngx-datatable-column>

                                <ngx-datatable-column name="" [width]="120" [sortable]="false">
                                    <ng-template let-row="row" ngx-datatable-cell-template>
                                        <div class="row justify-content-evenly">
                                            <a [href]="row.path" class="mr-1">
                                                <i data-feather="arrow-down" class="text-success cursor-pointer"></i>
                                            </a>
                                            <a appDelete controller="RequestTasks" [id]="row.id"
                                                action="RemoveRequestFile"
                                                (callback)="getByIdRequestTask(requestTask.id)">
                                                <i data-feather="trash" class="text-danger cursor-pointer"></i>
                                            </a>
                                        </div>
                                    </ng-template>
                                </ngx-datatable-column>

                                <ngx-datatable-footer>
                                    <ng-template ngx-datatable-footer-template>
                                        <div class="datatable-footer-inner">
                                            <div class="page-count">
                                                Toplam Veri {{ totalCount }}
                                            </div>
                                            <ngb-pagination [collectionSize]="(totalCount / basicSelectedOption) * 10"
                                                [(page)]="pageBasic" (pageChange)="onPageChange($event)">
                                                <ng-template ngbPaginationPrevious>
                                                    <span [data-feather]="'chevron-left'" [size]="18"
                                                        [class]="'font-weight-bolder'"></span>
                                                </ng-template>
                                                <ng-template ngbPaginationNext>
                                                    <span [data-feather]="'chevron-right'" [size]="18"
                                                        [class]="'font-weight-bolder'"></span>
                                                </ng-template>
                                            </ngb-pagination>
                                        </div>
                                    </ng-template>
                                </ngx-datatable-footer>
                            </ngx-datatable>

                            <!-- <table class="table" *ngIf="files.length > 0">
                                <thead>
                                    <tr>
                                        <th>Dosya Adı</th>
                                        <th>Dosya Türü</th>
                                        <th>#</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item2 of files">
                                        <td>
                                            {{item2.fileName}}
                                        </td>
                                        <td>{{ getFileExtension(item2.fileName) }}</td>
                                        <td>
                                            <div class="row justify-content-evenly">
                                                <a [href]="item2.path" class="mr-1">
                                                    <i data-feather="arrow-down"
                                                        class="text-success cursor-pointer"></i>
                                                </a>
                                                <a appDelete controller="RequestTasks" [id]="item2.id" action="RemoveRequestFile"
                                                    (callback)="getByIdRequestTask(requestTask.id)">
                                                    <i data-feather="trash" class="text-danger cursor-pointer"></i>
                                                </a>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table> -->
                        </div>
                    </div>
                </ng-template>
            </li>
        </ul>
        <div [ngbNavOutlet]="nav" class="mt-2"></div>
    </div>

    <div class="card col-12" *ngIf="!isUpdate">
        <div class="card-body">
            <form [formGroup]="requestForm" (ngSubmit)="onSubmit()">
                <div class="row">
                    <!-- Title -->
                    <div class="col-12 col-sm-6 col-md-4 mb-1">
                        <div class="form-group">
                            <label for="title">Talep Adı</label>
                            <input type="text" formControlName="title" class="form-control"
                                placeholder="Talep başlığı Giriniz." />
                            <div
                                *ngIf="requestForm.get('title').invalid && (requestForm.get('title').dirty || requestForm.get('title').touched)">
                                <small class="text-danger" *ngIf="requestForm.get('title').errors.required">Başlık
                                    zorunludur.</small>
                                <small class="text-danger" *ngIf="requestForm.get('title').errors.maxlength">Başlık
                                    en fazla 100 karakter olabilir.</small>
                            </div>
                        </div>
                    </div>

                    <!-- Oluşturma Tarihi -->
                    <div class="col-12 col-sm-6 col-md-4 mb-1">
                        <div class="form-group">
                            <label>Oluşturma Tarihi</label>
                            <ng2-flatpickr [config]="dateTimeStartOptions" name="dateTime" [setDate]="date"
                                formControlName="startDate"></ng2-flatpickr>
                        </div>
                    </div>

                    <!-- Bitiş Tarihi -->
                    <div class="col-12 col-sm-6 col-md-4 mb-1">
                        <div class="form-group">
                            <label>Bitiş Tarihi</label>
                            <ng2-flatpickr [config]="dateTimeEndOptions" name="dateTime" [setDate]="date2"
                                formControlName="endDate"></ng2-flatpickr>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <!-- Yetkili Kişi Seç -->
                    <div class="col-12 col-sm-6 col-md-4 mb-1">
                        <div class="form-group">
                            <label>Yetkili Kişi Seç</label>
                            <ng-select bindLabel="name" bindValue="id" formControlName="personId"
                                (change)="onCompanyPersonChange($event)">
                                <ng-option *ngFor="let user of companyPersons" [value]="user.id">{{user.name + ' '
                                    + user.lastname}}</ng-option>
                            </ng-select>
                        </div>
                    </div>

                    <!-- Firma -->
                    <div class="col-12 col-sm-6 col-md-4 mb-1">
                        <div class="form-group">
                            <label>Firma</label>
                            <ng-select [items]="companies" bindLabel="companyName" bindValue="id"
                                formControlName="companyId" (change)="onCompanyChange($event)">
                            </ng-select>
                        </div>
                    </div>

                    <!-- Firma Personelleri -->
                    <div class="col-12 col-sm-6 col-md-4 mb-1">
                        <div class="form-group">
                            <label>Firma Personelleri</label>
                            <ng-select bindValue="id" bindLabel="name" formControlName="companyPersonId"
                                (change)="onPersonChange($event)">
                                <ng-option *ngFor="let user of selectedPersons" [value]="user.id">{{user.name + ' '
                                    + user.lastname}}</ng-option>
                            </ng-select>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <!-- Açıklama -->
                    <div class="col-12 col-sm-6 col-md-4 mb-1">
                        <div class="form-group">
                            <label for="description">Açıklama</label>
                            <textarea formControlName="description" class="form-control"
                                placeholder="Talep Açıklaması Giriniz."></textarea>
                        </div>
                    </div>

                    <!-- Aciliyet Durumu -->
                    <div class="col-12 col-sm-6 col-md-4 mb-1">
                        <div class="form-group">
                            <label>Aciliyet Durumu</label>
                            <ng-select [items]="urgencyLevels" bindLabel="label" bindValue="value"
                                formControlName="urgency"></ng-select>
                        </div>
                    </div>

                    <!-- Durumu -->
                    <div class="col-12 col-sm-6 col-md-4 mb-1">
                        <div class="form-group">
                            <label>Durumu</label>
                            <ng-select [items]="statusList" bindLabel="label" bindValue="value"
                                formControlName="status"></ng-select>
                        </div>
                    </div>
                </div>

                <!-- Buttons -->
                <div class="row">
                    <div class="col-12 col-sm-6 col-md-4 mb-1">
                        <button type="submit" [disabled]="requestForm.invalid || !selectedCompany"
                            class="btn btn-primary col-12">Güncelle</button>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 mb-1">
                        <button type="reset" class="btn btn-outline-secondary col-12"
                            (click)="updateChange()">İptal</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>